// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p8-1";
export var messageSideRight = "_p8-2";
export var subscribeToBackInStockBubbleContainer = "_p8-0";